import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

// Layout
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Stay from './pages/Stay';
import Gallery from './pages/Gallery';
import Location from './pages/Location';
import Rates from './pages/Rates';
import Contact from './pages/Contact';

// Admin Pages
import AdminLogin from './pages/Admin/Login';
import Dashboard from './pages/Admin/Dashboard';
import ReviewsManagement from './pages/Admin/Reviews';
import BookingsManagement from './pages/Admin/Bookings';
import GalleryManagement from './pages/Admin/Gallery';
import AvailabilityManagement from './pages/Admin/Availability';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Conditional Layout Wrapper
const MainLayout = ({ children }) => {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith('/admin');

  if (isAdminPath) return children;

  return (
    <div className="flex flex-col min-h-screen bg-brand-cream font-sans text-brand-dark">
      <Navbar />
      {/* Removed pt-20 to eliminate redundant blank space at the top */}
      <main className="flex-grow">
        <AnimatePresence mode="wait">
          {children}
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <MainLayout>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/stay" element={<Stay />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/location" element={<Location />} />
          <Route path="/rates" element={<Rates />} />
          <Route path="/contact" element={<Contact />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Dashboard />} />
          <Route path="/admin/bookings" element={<BookingsManagement />} />
          <Route path="/admin/availability" element={<AvailabilityManagement />} />
          <Route path="/admin/reviews" element={<ReviewsManagement />} />
          <Route path="/admin/gallery" element={<GalleryManagement />} />
        </Routes>
      </MainLayout>
    </Router>
  );
}

export default App;